module.exports = __webpack_public_path__ + "static/media/High.38b534cf.svg";